export const tiktokScopes = (creatorDashboard: boolean) =>
  creatorDashboard
    ? "user.info.basic,video.upload,video.list"
    : "user.info.basic,video.upload";
